/* eslint-disable import/no-webpack-loader-syntax */
import React, { Component } from 'react';
import { Route, Switch, NavLink } from 'react-router-dom';
import { Row, Col, Menu, Alert } from 'antd';
// Highlight sucks
// import Highlight from 'react-highlight';
// import js from 'highlight.js/lib/languages/javascript';
// import xml from 'highlight.js/lib/languages/xml';
// SyntaxHighlighter sucks
// import SyntaxHighlighter, { registerLanguage } from "react-syntax-highlighter/dist/light"
// import js from 'react-syntax-highlighter/dist/languages/javascript';
// import xml from 'react-syntax-highlighter/dist/languages/xml';
// import railscasts from 'react-syntax-highlighter/dist/styles/railscasts';
// Prism ok
// import '!script-loader!prismjs/prism.js';
// import '!script-loader!prismjs/components/prism-jsx.min';
import 'prismjs/prism.js';
import 'prismjs/components/prism-jsx.min';
import { PrismCode } from "react-prism";

import SimpleForm from 'components/forms/SimpleForm';
// import SimpleFormContent from '!raw-loader!components/forms/SimpleForm.js';
import AsyncForm from 'components/forms/AsyncForm';
import UserForm from 'components/forms/UserForm';
import ComplexDataForm from 'components/forms/ComplexDataForm';
// import SimpleFormFile from '!file-loader?name=examples/[name].md!components/forms/SimpleForm.js';
// import logo from './logo.svg';
import './App.scss';
// import 'highlight.js/styles/agate.css';
import 'prismjs/themes/prism-coy.css';

// const prism = require('prismjs/prism');
// console.log(prism, prism.highlight("var data = 1;", prism.languages.javascript));

// registerLanguage('javascript', js);
// registerLanguage('xml', xml);

// const MenuItem = Menu.Item;

class App extends Component {
  render() {
    return (
      <div className="container">
        <div className="header">
          <div className="title">rx-model</div>

          <div className="menu">
            <NavLink to="/" exact>Simple Form</NavLink>

            <NavLink to="/async" exact>Async Form</NavLink>

            <NavLink to="/scenarios_user" exact>Scenarios</NavLink>

            <NavLink to="/complex_data" exact>Complex data</NavLink>

            {/*<NavLink to="/dynamic" exact>Dynamic Form</NavLink>

            <NavLink to="/scenarios_access" exact>Access</NavLink>

            <NavLink to="/scenarios_steps" exact>Steps</NavLink>*/}
          </div>
        </div>


        <Switch>
          <Route path="/" exact render={() => <div>
            <Alert
              message="Simple Form"
              description={<div>
                Простая форма регистрации пользователя.
              </div>}
              type="info"
              showIcon
            />

            <br />

            <Row gutter={15}>
              <Col span={10}>
                <SimpleForm/>
              </Col>

              <Col span={14}>
                <pre>
                <PrismCode className="language-jsx">
                  {require('!raw-loader!components/forms/SimpleForm')}
                </PrismCode>
                </pre>
              </Col>
            </Row>
          </div>} />

          <Route path="/async" render={() => <div>
            <Alert
              message="Async Form"
              description={<div>
                Асинхронная форма аналогична простой форме, с той лишь разницей, что поле&nbsp;
                <b>email</b> проводит дополнительную проверку на наличие емеила в системе
                (имитирует асинхронный запрос на сервер), емеилы <i>foo@mail.com</i> и&nbsp;
                <i>bar@mail.com</i> не пройдут валидацию.
              </div>}
              type="info"
              showIcon
            />

            <br />

            <Row gutter={15}>
              <Col span={10}>
                <AsyncForm/>
              </Col>

              <Col span={14}>
                <pre>
                <PrismCode className="language-jsx">
                  {require('!raw-loader!components/forms/AsyncForm')}
                </PrismCode>
                </pre>
              </Col>
            </Row>
          </div>} />

          <Route path="/scenarios_user" render={() => <div>
            <Alert
              message="Scenarios"
              description={<div>
                До этого были рассмотрены простые формы, несущие определенную функцию (регистрация
                пользователя). Но что если функций много? Для этого есть механизм сценариев, с его
                помощью можно описать множество поведений в рамках одной сущности.
                В данном случае сущность "пользователь" имеет несколько моделей поведения:
                регистрация, авторизация, редактирование профиля, смена пароля.
              </div>}
              type="info"
              showIcon
            />

            <br />

            <Row gutter={15}>
              <Col span={10}>
                <UserForm/>
              </Col>

              <Col span={14}>
                <pre>
                <PrismCode className="language-jsx">
                  {require('!raw-loader!components/forms/UserForm')}
                </PrismCode>
                </pre>
              </Col>
            </Row>
          </div>} />

          <Route path="/complex_data" render={() => <div>
            <Alert
              message="Complex data"
              description={<div>
                Формы могут работать с данными любой вложенности.
              </div>}
              type="info"
              showIcon
            />

            <br />

            <Row gutter={15}>
              <Col span={10}>
                <ComplexDataForm/>
              </Col>

              <Col span={14}>
                <pre>
                <PrismCode className="language-jsx">
                  {require('!raw-loader!components/forms/ComplexDataForm')}
                </PrismCode>
                </pre>
              </Col>
            </Row>
          </div>} />
          <Route path="/access" render={() => <div>Access Form</div>} />
          <Route render={() => <div>Page not found!</div>} />
        </Switch>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js